import { useAppSelector } from "../store/index";

export const usePermissions = (currentSection: string): string[] | null => {
  const isAuthorized = useAppSelector((store) => store.auth.isAuthorized);
  const permissions = useAppSelector((store) => store.auth.info?.permissions);
  const info = useAppSelector((store) => store.auth.info);
  const isAdmin = useAppSelector(
    (store) => store.auth.info?.roleName === "admin",
  );

  const result = () => {
    if (!isAuthorized || !info) return null;
    if (isAdmin) {
      return [
        "read",
        "create",
        "update",
        "delete",
        "export",
        "read_user_contacts",
      ];
      // @ts-ignore
    } else if (permissions && permissions[currentSection]) {
      // @ts-ignore
      return permissions[currentSection];
    }
    return [];
  };

  return result();
};
